import { render } from "./RewardsInfoPage.vue?vue&type=template&id=22c6a2bd&scoped=true"
import script from "./RewardsInfoPage.vue?vue&type=script&lang=js"
export * from "./RewardsInfoPage.vue?vue&type=script&lang=js"

import "./RewardsInfoPage.vue?vue&type=style&index=0&id=22c6a2bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6a2bd"]])

export default __exports__